import {Pipe, PipeTransform} from '@angular/core';
import {UnitAdvertisementDto} from "homey-housing-lottery-app-dto";

@Pipe({
  name: 'minHouseholdSize',
  standalone: true
})
export class MinHouseholdSizePipe implements PipeTransform {
  transform(advertisements: UnitAdvertisementDto[]): number {
    return Math.min(...advertisements.map(advertisement => advertisement.householdSize));
  }
}
